export interface ContactSocialAccount {
    uuid: string;
    name?: string;
    handle: string;
    platform: string;
    followers_count: number;
    average_views?: number;
    engagement_score?: string | number;
    profile_picture_url: string;
}

export interface ContactInfluencer {
    uuid: string;
    name?: string;
    mobile?: string;
}

export interface Contact {
    id: number;
    mobile: string;
    platform: string;
    handle: string;
    social_account: ContactSocialAccount;
    influencer: ContactInfluencer | null;
    tags: string[];
    error?: string;
    created: string;
}

export interface ContactResponse {
    count: number;
    items: Contact[];
    unprocessed: number;
    failed: number;
}

export interface CreatorsReducerState {
    loading: boolean;
    error: string | null;
    filters: CreatorContactsFilters;
    applied_filter_id: string | null;
    total: number;
    unprocessed: number;
    failed: number;
    filtered_lists: Record<string, {
        list: Contact[];
        count: number;
        page: number;
        last_fetched_at: number | null;
        expired: boolean;
        has_more: boolean;
    }>;
}

export enum CreatorSortOptions {
    LATEST = 'latest',
    FOLLOWERS = 'followers_count',
    ENGAGEMENT = 'engagement_score',
    AVERAGE_VIEWS = 'average_views',
}

export const CreatorSortOptionLabel = {
    [CreatorSortOptions.LATEST]: 'Latest',
    [CreatorSortOptions.FOLLOWERS]: 'Followers',
    [CreatorSortOptions.ENGAGEMENT]: 'Engagement',
    [CreatorSortOptions.AVERAGE_VIEWS]: 'Average Views',
}

export interface CreatorContactsFilters {
    q?: string;
    page: number;
    sort: CreatorSortOptions;
    platform?: string;
    average_views?: number;
    average_followers?: number;
    followers_count?: number;
    engagement_score?: number;
    unprocessed?: 'y';
    has_error?: 'y';
    [key: string]: any;
}

export const defaultCreatorContactsFilters: CreatorContactsFilters = {
    sort: CreatorSortOptions.LATEST,
    page: 1,
}

export interface AddContactPayload {
    handle: string;
    tags: string[];
    platform: string;
}

export interface BulkContactItem {
    handle: string;
    tags: string[];
}

export interface BulkAddContactsPayload {
    platform: string;
    contacts: BulkContactItem[];
}

export type BulkUploadColumnField = 'handle' | 'tags' | 'skip';

export type CreatorsListTab = 'all' | 'unprocessed' | 'failed';

export interface UpdateContactMobilePayload {
    mobile: string;
    country_code: string;
    otp?: string;
}

export enum Platform {
    ALL = 'all',
    IG = 'ig',
    YT = 'yt',
}

export const PlatformLabel = {
    [Platform.ALL]: 'All',
    [Platform.IG]: 'Instagram',
    [Platform.YT]: 'YouTube',
}

export interface CreatorTag {
    id: number;
    tag: string;
}
